import { LoggedUser } from "../../../redux/store";
import { Account } from "@idha/idha-types";
import * as R from "ramda";
import { ModulePermissions, PermissionsPipeData } from "./base-classes";
import { hasRole } from "redux/helperFunctions/loggedUser.helperFunctions";

export class AccountsAccessPermissions extends ModulePermissions{
    accountantManagement:boolean = true;
    agencySettigs:boolean = true;

    constructor(){
        super();
    }
}

export class AccountsPermissionsPipeData extends PermissionsPipeData<AccountsAccessPermissions>{    
    account: Account

    constructor(loggedUser: LoggedUser,account: Pick<Account,'id'|'accountType'|'bank'>) {
        super(loggedUser,new AccountsAccessPermissions());
        this.account = account;
    }
}

namespace AccessRules {    
    export function accountNotInformed(data: AccountsPermissionsPipeData): AccountsPermissionsPipeData {
         if(!data.account){
            data.disableAllKeys()
        }

        return data;
    }

    export function accountTypeOther(data: AccountsPermissionsPipeData): AccountsPermissionsPipeData {
        if(data.account?.accountType == 'OTHER'){
            data.disableAllKeys()
        }

        return data;
    }

    export function accountTypeNotAgency(data: AccountsPermissionsPipeData): AccountsPermissionsPipeData {
        if(data.account?.accountType != 'AGENCY'){
            data.permissions.accountantManagement = false;
            data.permissions.agencySettigs = false;
        }

        return data;
    }
    
    export function role(data: AccountsPermissionsPipeData): AccountsPermissionsPipeData {
        if (hasRole(data.loggedUser,'admin')) return data;
        
        data.permissions.agencySettigs = false;

        if (!hasRole(data.loggedUser,"packing.accountOperator.agency")) {
            if (data.account?.accountType == "AGENCY") {
                data.permissions.accountantManagement = false;
            }
        }

        return data;
    }

    export function isIdhaAdmin(data: AccountsPermissionsPipeData) : AccountsPermissionsPipeData {
        if (hasRole(data.loggedUser,'idhaAdmin')) {
            data.permissions.agencySettigs = true
        }

        return data
    }

    export function accountTypeIsAgency(data: AccountsPermissionsPipeData) : AccountsPermissionsPipeData {
        if (data.account?.accountType == "AGENCY" && !hasRole(data.loggedUser, 'idhaAdmin')) {
            data.permissions.agencySettigs = false
        }

        return data
    }

    export function end(data: AccountsPermissionsPipeData):AccountsAccessPermissions{
        return data.permissions
    }

}


export default R.pipe(
    AccessRules.accountNotInformed,
    R.pipe(
        AccessRules.accountTypeOther,
        AccessRules.accountTypeNotAgency,
        AccessRules.isIdhaAdmin,
        AccessRules.accountTypeIsAgency
    ),
    AccessRules.role,
    AccessRules.end
);